import { Column } from 'app/design/primitives/box';
import { Text } from 'app/design/primitives/text';
import { useTranslation } from 'react-i18next';

export function EmptyState() {
  const { t } = useTranslation('notifications');
  return (
    <Column flex={1} alignItems="center" justifyContent="center" padding="spacing.general.x12" gap="spacing.general.x3">
      <Text fontSize={40}>🔔</Text>
      <Text fontWeight="700" fontSize={17} textAlign="center">
        {t('emptyState.title', { defaultValue: 'Aucune notification' })}
      </Text>
      <Text fontSize={14} color="text.secondary" textAlign="center">
        {t('emptyState.subtitle', {
          defaultValue: 'Les notifications de tes prêts, emprunts et favoris apparaîtront ici.',
        })}
      </Text>
    </Column>
  );
}
